export default "__VITE_ASSET__DZM7bfZM__"